import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import QuickPublishForm from './components/QuickPublishForm';
import ActiveBagsTable from './components/ActiveBagsTable';
import BusinessAnalytics from './components/BusinessAnalytics';
import CertificationProgress from './components/CertificationProgress';
import EndOfDayTools from './components/EndOfDayTools';
import TrainingResources from './components/TrainingResources';

const BusinessDashboard = () => {
  const [activeBags, setActiveBags] = useState([]);
  const [activeTab, setActiveTab] = useState('overview');

  const handlePublishBag = (bagData) => {
    setActiveBags((prev) => [bagData, ...prev]);
    console.log('New bag published:', bagData);
  };

  const handleUpdateBag = (bagId) => {
    console.log('Update bag:', bagId);
  };

  const handleGenerateQR = (bagId) => {
    console.log('Generate QR for bag:', bagId);
  };

  const tabOptions = [
  { id: 'overview', label: 'Resumen', icon: 'BarChart3' },
  { id: 'analytics', label: 'Análisis', icon: 'TrendingUp' },
  { id: 'certification', label: 'Certificación', icon: 'Award' },
  { id: 'tools', label: 'Herramientas', icon: 'Settings' },
  { id: 'training', label: 'Capacitación', icon: 'GraduationCap' }];


  return (
    <>
      <Helmet>
        <title>Panel de Negocio - FoodRescue</title>
        <meta name="description" content="Gestiona tu inventario de comida, reduce el desperdicio y aumenta tus ingresos con FoodRescue. Panel completo para negocios de alimentos." />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="pt-16">
          <div className="max-w-7xl mx-auto px-4 lg:px-6 py-6">
            {/* Page Header */}
            <div className="mb-8">
              <div className="flex items-center justify-between">
                <div>
                  <h1 className="text-3xl font-heading font-bold text-foreground">
                    Panel de Negocio
                  </h1>
                  <p className="text-muted-foreground mt-2">
                    Gestiona tu inventario y reduce el desperdicio de alimentos
                  </p>
                </div>
                
                <div className="flex items-center space-x-4">
                  {/* Cafe Photo */}
                  <div className="w-16 h-16 rounded-lg overflow-hidden border-2 border-primary/20">
                    <img
                      src="https://images.unsplash.com/photo-1724309266428-a037c1e2e686"
                      alt="Cafe Central - Interior view showing cozy seating area with warm lighting and coffee brewing equipment"
                      className="w-full h-full object-cover" />

                  </div>
                  
                  <div className="text-right">
                    <div className="text-sm text-muted-foreground">Café Central</div>
                    <div className="text-lg font-semibold text-foreground">
                      Abierto hasta 20:00
                    </div>
                  </div>
                  <div className="w-3 h-3 bg-success rounded-full animate-pulse-soft"></div>
                </div>
              </div>
            </div>

            {/* Tab Navigation */}
            <div className="mb-8">
              <div className="border-b border-border">
                <nav className="flex space-x-8 overflow-x-auto">
                  {tabOptions?.map((tab) =>
                  <button
                    key={tab?.id}
                    onClick={() => setActiveTab(tab?.id)}
                    className={`flex items-center space-x-2 py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors ${
                    activeTab === tab?.id ?
                    'border-primary text-primary' : 'border-transparent text-muted-foreground hover:text-foreground hover:border-muted'}`
                    }>

                      <span>{tab?.label}</span>
                    </button>
                  )}
                </nav>
              </div>
            </div>

            {/* Tab Content */}
            {activeTab === 'overview' &&
            <div className="space-y-8">
                {/* Quick Publish Form */}
                <QuickPublishForm onPublish={handlePublishBag} />
                
                {/* Active Bags Table */}
                <ActiveBagsTable
                bags={activeBags}
                onUpdateBag={handleUpdateBag}
                onGenerateQR={handleGenerateQR} />

              </div>
            }

            {activeTab === 'analytics' &&
            <BusinessAnalytics />
            }

            {activeTab === 'certification' &&
            <CertificationProgress />
            }

            {activeTab === 'tools' &&
            <EndOfDayTools />
            }

            {activeTab === 'training' &&
            <TrainingResources />
            }
          </div>
        </main>
      </div>
    </>);

};

export default BusinessDashboard;